const GET_GUEST_CART_ID = "GET_GUEST_CART_ID";
const GET_GUEST_CART_PRODUCTS = "GET_GUEST_CART_PRODUCTS";
const SET_CART_PRICE_AND_QTY = "SET_CART_PRICE_AND_QTY";

export { GET_GUEST_CART_ID, GET_GUEST_CART_PRODUCTS, SET_CART_PRICE_AND_QTY };



// WEBPACK FOOTER //
// ./src/modules/Cart/actions/types.js